import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import VerifyCodePage from "./pages/VerifyCodePage";
import RequireAuth from "./RequireAuth";
import DmarcDashboard from "./pages/DmarcDashboard.jsx";
import IpDetallePage from "./pages/IpDetallePage.jsx";
import IpInvalidDetail from "./pages/IpInvalidDetail";
import RecordDetail from "./pages/RecordDetail.jsx";
import DetalleIpInvalida from "./pages/DetalleIpInvalida";
import PasswordRecoveryPage from "./pages/PasswordRecovery.jsx";
import ChangePasswordPage from "./pages/ChangePassword.jsx";
import DmarcOne from "./pages/DmarcOne.jsx";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <RequireAuth>
              <DmarcOne />
            </RequireAuth>
          }
        />
        {/* ambas rutas válidas */}
        <Route
          path="/ip-detalle"
          element={
            <RequireAuth>
              <IpDetallePage />
            </RequireAuth>
          }
        />
        <Route
          path="/ip/:ip"
          element={
            <RequireAuth>
              <IpDetallePage />{" "}
            </RequireAuth>
          }
        />
        <Route
          path="/record/:recordid"
          element={
            <RequireAuth>
              <RecordDetail />
            </RequireAuth>
          }
        />
        <Route
          path="/ip/:ip"
          element={
            <RequireAuth>
              <IpInvalidDetail />{" "}
            </RequireAuth>
          }
        />
        <Route
          path="/detalle-ip-invalida"
          element={
            <RequireAuth>
              <DetalleIpInvalida />
            </RequireAuth>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/verify-code" element={<VerifyCodePage />} />
        <Route path="/password-recovery" element={<PasswordRecoveryPage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
      </Routes>
    </BrowserRouter>
  );
}
